import { TheProof, TheDMs, CandidateProfile, Opportunity } from "../types";
import { ChatThreadMessage } from "../components/chat/types";
import { getStagePrompt } from "./useStageDirector";
import { msgId } from "../utils/chat";

export function seedThread(
  opportunity: Opportunity,
  proof: TheProof[],
  profile: CandidateProfile | undefined,
  dms: TheDMs[],
): ChatThreadMessage[] {
  const messages: ChatThreadMessage[] = [];

  messages.push({
    type: "stage_marker",
    id: msgId("stage"),
    stage: opportunity.current_stage,
    label: opportunity.current_stage.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    timestamp: opportunity.created_at,
  });

  const items: { timestamp: string; msg: ChatThreadMessage }[] = [];
  for (const p of proof) {
    items.push({
      timestamp: p.created_at,
      msg: {
        type: "proof_card",
        id: msgId("proof_card"),
        proofId: p.proof_id,
        timestamp: p.created_at,
      },
    });
  }
  if (profile) {
    items.push({
      timestamp: profile.updated_at,
      msg: {
        type: "profile_card",
        id: msgId("profile_card"),
        profileId: profile.profile_id,
        timestamp: profile.updated_at,
      },
    });
  }
  for (const dm of dms) {
    items.push({
      timestamp: dm.created_at,
      msg: { type: "dm_card", id: msgId("dm_card"), dmId: dm.dm_id, timestamp: dm.created_at },
    });
  }

  items.sort((a, b) => a.timestamp.localeCompare(b.timestamp));
  for (const item of items) messages.push(item.msg);

  const prompt = getStagePrompt(opportunity.current_stage);
  messages.push({
    type: "ai",
    id: msgId("ai"),
    expert: prompt.expert,
    text: prompt.text,
    timestamp: new Date().toISOString(),
    modalSuggestion: prompt.modalSuggestion,
  });

  return messages;
}
